import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-password-field',
  templateUrl: './password-field.component.html',
  styleUrls: ['./password-field.component.scss']
})
export class PasswordFieldComponent {
  // Named `control` (not `formControl`) so it does not collide with Angular's
  // FormControlDirective on the host element, which would require a
  // ControlValueAccessor and throw NG01203. The inner native <input> does the
  // real form binding; this input just hands the FormControl in.
  @Input() control: any;

  onPasswordBlur(): void {
    if (this.control.value) {
      const trimmed = this.control.value.trim();
      this.control.setValue(trimmed);
    }
  }
}
